var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-crud',{attrs:{"crudName":"Turnos","newText":"Novo Turno","table":_vm.shiftTable,"columns":_vm.columns,"options":_vm.options,"endPoint":_vm.endPoint,"enableAdd":true,"enableEdit":true,"enableDelete":true,"enableView":false}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-afd81c4a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shift/Crud.vue
// module id = null
// module chunks = 